import React, { Component } from "react";
import { connect } from "react-redux";
import styles from "./VisualitzacioMapaTitol.module.css";
import PropTypes from "prop-types";
import {
  getEspecieFenofaseSeleccionada,
  getTotesFenofases,
  getTotesEspecies
} from "../../reducers";

class VisualitzacioMapaTitol extends Component {
  shouldComponentUpdate(nextProps) {
    const novaIdEspecie = nextProps.especieFenofaseSeleccionada.idEspecie;
    const novaIdFenofase = nextProps.especieFenofaseSeleccionada.idFenofase;
    const actualIdEspecie = this.props.especieFenofaseSeleccionada.idEspecie;
    const actualIdFenofase = this.props.especieFenofaseSeleccionada.idFenofase;

    return (
      novaIdEspecie !== actualIdEspecie || novaIdFenofase !== actualIdFenofase
    );
  }

  getFenofaseSeleccionada = (listaFenofases, idFenofase) => {
    return listaFenofases.filter(fenofase => {
      return fenofase.id === idFenofase;
    });
  };

  getEspecieSeleccionada = (listaEspecies, idEspecie) => {
    return listaEspecies.filter(especie => {
      return especie.id === idEspecie;
    });
  };

  getNomEspecieFenofase = () => {
    const { especies, fenofases, especieFenofaseSeleccionada } = this.props;

    if (!especieFenofaseSeleccionada) {
      return null;
    }

    const idEspecie = especieFenofaseSeleccionada.idEspecie
      ? especieFenofaseSeleccionada.idEspecie
      : null;
    const idFenofase = especieFenofaseSeleccionada.idFenofase
      ? especieFenofaseSeleccionada.idFenofase
      : null;

    if (!idEspecie || !idFenofase) {
      return null;
    }

    const especieSeleccionada = this.getEspecieSeleccionada(
      especies,
      idEspecie
    );

    const fenofaseSeleccionada = this.getFenofaseSeleccionada(
      fenofases,
      idFenofase
    );
    return `${especieSeleccionada[0].nom}: ${fenofaseSeleccionada[0].nom}`;
  };

  render() {
    const titolEspecieFenofase = this.getNomEspecieFenofase();
    return (
      <div className={styles.MapaTitol}>
        <h2>{titolEspecieFenofase}</h2>
      </div>
    );
  }
}

VisualitzacioMapaTitol.propTypes = {
  especieFenofaseSeleccionada: PropTypes.object,
  fenofases: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      nom: PropTypes.string.isRequired,
      idEspecie: PropTypes.number.isRequired
    })
  ),
  especies: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      nom: PropTypes.string.isRequired
    })
  )
};

const mapStateToProps = state => ({
  especieFenofaseSeleccionada: getEspecieFenofaseSeleccionada(state),
  especies: getTotesEspecies(state),
  fenofases: getTotesFenofases(state)
});

export default connect(mapStateToProps)(VisualitzacioMapaTitol);
